import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { createPinia } from "pinia";
import { loadFonts } from "./plugins/webfontloader";
import { vMaska } from "maska/vue";
import { JL } from "jsnlog";
import VuelidatePlugin from "@vuelidate/core";
import ganttastic from "@infectoone/vue-ganttastic";

loadFonts();
const pinia = createPinia();

const app = createApp(App);

app.config.errorHandler = (err) => {
  // `info` is a Vue-specific error info, e.g. which lifecycle hook the error was found in.
  console.log(err);

  JL().fatalException("Uncaught Exception", err);
};

window.onerror = (error) => {
  try {
    JL().fatalException("windows.onerror", error);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    // Do nothing..
  }

  console.log("windows.onerror", error);
};

app
  .directive("maska", vMaska)
  .use(router)
  .use(vuetify)
  .use(ganttastic)
  .use(pinia)
  .use(VuelidatePlugin)
  .mount("#app");
